import React from "react";
import moment from "moment";
import { useIntl } from "react-intl";
import { Form, DatePicker } from "antd";

import {
  datePickerFormat,
  dateTimeApiFormat,
  dateTimeFormatForPrint,
} from "../../../../index";

/**
 * vrátí hodnotu z výsledku DatePicker, pokud existuje, a vrátí řetězcovou reprezentaci
 * @param {string} value výsledek DatePicker
 */
export const getDateFromDatePicker = (value) =>
  value && value.format(dateTimeApiFormat);

/**
 * nastaví čas na 23:59:59
 * @param {Moment} moment moment objekt
 */
export const setEndOfTheDay = (moment) =>
  moment.hours(23).minutes(59).seconds(59);

export const setStartOfTheDay = (moment, zero) =>
  moment
    .hours(0)
    .minutes(0)
    .seconds(zero ? 0 : 1)
    .milliseconds(0);

const { Item } = Form;
const zeroTime = moment("00:00:00", "HH:mm:ss");
export const today = setEndOfTheDay(moment(moment.now()).add(-1, "d")),
  tommorow = setEndOfTheDay(moment(moment.now())),
  year = setEndOfTheDay(moment(moment.now()).add(-1, "y"));

const DateItem = ({
  getFieldDecorator,
  zeroDefaultTime,
  formItemLayout,
  onValidation,
  placeholder,
  initialDate,
  wrapperCol,
  className,
  fromToday,
  fieldName,
  fromYear,
  onChange,
  disabled,
  labelCol,
  optional,
  required,
  showTime,
  message,
  label,
}) => {
  const intl = useIntl();
  return (
    <Item
      label={label}
      className={className}
      labelCol={labelCol ? { span: labelCol } : formItemLayout.labelCol}
      wrapperCol={wrapperCol ? { span: wrapperCol } : formItemLayout.wrapperCol}
    >
      {getFieldDecorator(fieldName, {
        ...{ initialValue: initialDate },
        rules: [
          {
            required: (required || message) && !optional,
            message: required
              ? intl.formatMessage({
                  id: "messages.input.required",
                  defaultMessage: "Tento údaj je povinný!",
                })
              : message,
          },
          ...(onValidation
            ? [
                {
                  validator: onValidation,
                },
              ]
            : []),
        ],
      })(
        <DatePicker
          showTime={
            showTime
              ? zeroDefaultTime
                ? {
                    defaultValue: zeroTime,
                  }
                : true
              : undefined
          }
          onChange={onChange}
          disabled={disabled}
          placeholder={
            placeholder ||
            intl.formatMessage({
              id: "messages.chooseDate",
              defaultMessage: "Vyberte datum",
            })
          }
          format={showTime ? dateTimeFormatForPrint : datePickerFormat}
          disabledDate={(d) =>
            !d || d.isBefore(fromToday ? today : fromYear ? year : tommorow)
          }
        />
      )}
    </Item>
  );
};

export default DateItem;
